import { Directive, Inject } from '@angular/core'
import { ScriptLoader } from '@sun-finance/utils'
import { take } from 'rxjs'
import { SupportedScripts } from '@features/script-loader'
import { RECAPTCHA_SITE_KEY } from "@features/recaptcha/recaptcha.config"

@Directive({
  selector: 'app-google-recaptcha-wrapper, [appGoogleRecaptchaWrapper]',
  standalone: true,
})
export class GoogleRecaptchaWrapperDirective {
  constructor(
    private loader: ScriptLoader,
    @Inject(RECAPTCHA_SITE_KEY) private siteKey: string,
  ) {
    this.loader.load(SupportedScripts.GOOGLE_RECAPTCHA, {srcParams: {siteKey: this.siteKey}}).pipe(take(1)).subscribe()
  }
}
